import React from 'react';
import { Button, FormControl, Box } from '@material-ui/core';
import * as Yup from 'yup';
import { useSelector } from 'react-redux';
import { FormBodyAPI } from '../../constants/fieldsTypes';
import { MultiCategorySelect } from '../Select/MultiCategorySelect';
import { CLIENT_TYPE } from '../../constants/multiSelectConsts';
import { RootState } from '../../store';
import { RouteContext, PortalConfigContext } from '../../context';

const validationScheme = Yup.object().shape({
  fields: Yup.object().shape({
    recipientIds: Yup.array()
      .of(Yup.string())
      .test(
        'clients-array',
        'Please select at least one client.',
        value => value.length > 0,
      ),
  }),
});

export const useIntakeSendForm = (selectedFormId?: string) => {
  const clientUsers = useSelector(
    (state: RootState) => state.clients.assignedClients,
  );

  const portalConfig = React.useContext(PortalConfigContext);
  const { query } = React.useContext(RouteContext);

  const getSubmitValues = async () => ({});

  // Filter users by formId
  const getUsersWithForm = () => {
    const formId = query.formId || selectedFormId;
    const filtered = clientUsers
      .filter(
        c =>
          c.additionalFields &&
          c.additionalFields?.formsAssociated?.includes(formId),
      )
      .map(c => c.id);
    return filtered;
  };

  const FormRenderer: React.FC<FormBodyAPI> = ({
    errors,
    values,
    setFieldValue,
  }) => {
    const handleRecipientChange = (_: any, vals: any[] | any) => {
      const clientsIds = vals.map(val => val.id);
      setFieldValue('fields.recipientIds', clientsIds);
    };

    const selectAllClients = () => {
      const formId = query.formId || selectedFormId;
      const filteredUsersOptionsWithoutForm = clientUsers
        .filter(
          c =>
            !(
              c.additionalFields &&
              c.additionalFields?.formsAssociated?.includes(formId)
            ),
        )
        .map(u =>
          u.fields.given_name ? `${portalConfig.portalHeader}_${u.id}` : u.id,
        );
      setFieldValue('fields.recipientIds', filteredUsersOptionsWithoutForm);
    };

    return (
      <>
        <FormControl fullWidth style={{ marginBottom: 0 }}>
          <MultiCategorySelect
            multiple
            includeInternalUsers={false}
            includeClientUsers
            optionToExclude={[]}
            filterResultsLimit={0}
            values={values.fields.recipientIds || []}
            id="clients-select"
            label="Select recipients"
            onChange={handleRecipientChange}
            placeholder="Type to find clients"
            showPlaceholder
            disabled={values.fields.disabled}
            showClientsInOtherCompanies
            helperText={errors.fields && errors.fields.recipientIds}
            error={!!(errors.fields && errors.fields.recipientIds)}
            showSelectAllGroupButtons={[CLIENT_TYPE]}
            disabledUserIDs={getUsersWithForm()}
          />
        </FormControl>
        <Box mt={1.75} textAlign="right">
          <Button
            variant="contained"
            onClick={selectAllClients}
            color="secondary"
          >
            Select all clients
          </Button>
        </Box>
      </>
    );
  };

  return { validationScheme, getSubmitValues, FormRenderer };
};
